export const formatNumber = (num) => {
    if (!Number.isFinite(num)) return '';
    return num.toLocaleString("ru-RU");
}